import type { CreditsStoredSnapshot } from './types';

/**
 * Identifies a stored snapshot. The coordinator uses it to dedupe snapshot replays, and the provider
 * uses it to recognize a replay of a snapshot that a reported denial replaced, so both must agree.
 */
export const getStoredSnapshotId = ({
	leaderTabId,
	updatedAt,
}: Pick<CreditsStoredSnapshot, 'leaderTabId' | 'updatedAt'>): string =>
	`${leaderTabId}:${updatedAt}`;
